//import {Country} from '../models/country.js';
//TODO make better use of the Country model

import {convert} from './dataHandlerService';
import store from '../store';

// Utility function to convert risk value to numeric value
function riskToNumeric(risk: string | number): number {
    if (typeof risk === 'number') return risk;
    
    const baseValue = parseInt(risk);
    if (isNaN(baseValue)) return 0;
    
    // TODO make sure this is the correct way to handle the + and - signs
    if (risk.endsWith('+')) return baseValue - 0.3;
    if (risk.endsWith('-')) return baseValue + 0.3;
    return baseValue;
}

// Calculate the difference between current and previous risk values
function calculateRiskDifference(current: string | number, previous: string | number): number {
    const currentValue = riskToNumeric(current);
    const previousValue = riskToNumeric(previous);
    return currentValue - previousValue;
}
export  class Service{

    static async setAllCountries(){
        const countries = await convert();
        store.dispatch('countryStoreData/setAllCountries', countries);
    }

    static getAllCountries():any[]{
        return store.getters['countryStoreData/allCountries'];
    }

    static async newCountrySelected(country_code:string) : Promise<any> {

        return this.getCountryKeyData(country_code);
    }

    static getCountryByObjectCode(country_object_code:string){
        const countries = Service.getAllCountries();
        for (let i = 0; i < countries.length; i++) {
            const tempCountry:any = countries[i] ;
            if(tempCountry.country_object_code === country_object_code){
                return tempCountry;
            }
        }
    }

    static getCountryKeyData(iso:string){
        const countries = Service.getAllCountries();
        
        for (let i = 0; i < countries.length; i++) {
            const tempCountry:any = countries[i] ;
            if(tempCountry.iso === iso){
                return tempCountry;
            }
        }
    }

    static getMovementDirection(country: any): 'up' | 'down' | 'stable' {
        const difference = calculateRiskDifference(
            country.riskData[0].star,
            country.riskData[0].star_previous_quarter
        );
        
        if (difference > 0) return 'up';
        if (difference < 0) return 'down';
        return 'stable';
    }

    static getMovementValue(country: any): number {
        const difference = calculateRiskDifference(
            country.riskData[0].star,
            country.riskData[0].star_previous_quarter
        );
        return Math.abs(difference);
    }

    static getMovementDifference(country: any): number {
        return calculateRiskDifference(
            country.riskData[0].star,
            country.riskData[0].star_previous_quarter
        );
    }
    
    static getRiskCat(country:any) {    
        return country.riskData[0].risk_cat 
    }

    static getStarCat(country:any){
        return country.riskData[0].star;
    }

    static getPreviousStarRating(country:any){
        return country.riskData[0].star_previous_quarter;
    }

    static getMovementFocusCountries(countryCount:number){

        const countries = Service.getAllCountries();
        const countryList: any[] = [];
        for(let i = 0; i < countries.length; i++){
            if(countries[i].riskData.length > 0 && countries[i].riskData[0].selected_for_movement_focus != ""){
                countryList.push(countries[i]);
            }
        }

        countryList.sort((a,b) => {
            return a.riskData[0].selected_for_movement_focus - b.riskData[0].selected_for_movement_focus;
        });

        return countryList.slice(0,countryCount);        
    }

    static hasIndustryPerformanceData(country:any){
        if(country.industryPerformance.length > 0){
            return true;    
        }
        return false;
    }

    static hasESGData(country:any){
        const isValid = true;
        let totalChecked = 0;
        let totalFailed = 0;

        
        totalChecked++;
        if(country.esgData.environmental && country.esgData.environmental.inform.data.length === 0){
            totalFailed++;
        }

        totalChecked++;
        if(country.esgData.environmental && country.esgData.environmental.re.data.length === 0){
            totalFailed++;
        }

        totalChecked++;
        if(country.esgData.governance.corruption.data.length === 0){
            totalFailed++;
        }

        totalChecked++;
        if(country.esgData.governance.wgi.ge.data.length === 0){
            totalFailed++;
        }

        totalChecked++;
        if(country.esgData.governance.wgi.pols.data.length === 0){
            totalFailed++;
        }

        totalChecked++;
        if(country.esgData.governance.wgi.rq.data.length === 0){
            totalFailed++;
        }

        totalChecked++;
        if(country.esgData.social.fsi.data.length === 0){
            totalFailed++;
        }

        totalChecked++;
        if(country.esgData.social.hdi.data.length === 0){
            totalFailed++;
        }

        if(totalChecked === totalFailed){
            return false;
        }else{
            return true;
        }
    }

    static hasRiskData(country:any){
        if(country.riskData.length > 0){
            return true;
        }
        return false;
    }

    static hasKeyFiguresData(country:any){
        if(country.gdp.length > 0){
            return true;
        }
        return false;
    }

}